module.exports = __webpack_public_path__ + "static/digital-danismanlik-d9325cd83c9248cb2947a6adb51b80a3.png";